module.exports = __webpack_public_path__ + "img/client_logo_alpha.f3375ab4.webp";